import { REQUERT_NEW_PLANHANDLE_FAILED, GET_DATA_NEW_PLANHANDLE_SUCCEEDED, CLEAR_DATA_NEW_PLANHANDLE 
,GET_DATA_ACTION_LinkApi_SUCCEEDED,GET_DATA_ACTION_LinkApi_FAILED
,GET_DATA_ACTION_LinkApibyid_SUCCEEDED,GET_DATA_ACTION_LinkApibyid_FAILED,
GET_DATA_EMAIL_AZURE_SUCCEEDED, REQUEST_DATA_EMAIL_AZURE_FAILED, GET_DATA_VALIDATE_DATE_SUCCEEDED, REQUEST_GET_DATA_VALIDATE_DATE_FAILED, GET_DATA_PLAN_BY_PASS_SUCCEEDED, REQUEST_DATA_PLAN_BY_PASS_FAILED
} from '../actions/actionTypes'

export const newReducer = (DataNew = [], actions) => {
    switch (actions.type) {
        case CLEAR_DATA_NEW_PLANHANDLE:
            return {...DataNew,DataNew: []}
        case GET_DATA_NEW_PLANHANDLE_SUCCEEDED:
            if(Object.keys(actions.DataNew).length > 0)
            {
                return {...DataNew,DataNew: actions.DataNew};
            }
            else
            {
                return {...DataNew,DataNew: []};
            }
        case REQUERT_NEW_PLANHANDLE_FAILED:
            return {...DataNew,DataNew: []};
        default:
            return DataNew;
    }
}

export const DataLinkApiReducer = (DataLinkApi = [], actions) => {
    switch (actions.type) {
        case GET_DATA_ACTION_LinkApi_SUCCEEDED:
            if(Object.keys(actions.DataLinkApi).length > 0)
            {
                return {...DataLinkApi,DataLinkApi: actions.DataLinkApi};
            }
            else
            {
                return {...DataLinkApi,DataLinkApi: []};
            }
        case GET_DATA_ACTION_LinkApi_FAILED:
            return {...DataLinkApi,DataLinkApi: []};
        default:
            return DataLinkApi;
    }
}
export const DataLinkApibyidReducer = (DataLinkApibyid = [], actions) => {
    switch (actions.type) {
        case GET_DATA_ACTION_LinkApibyid_SUCCEEDED:
            if(Object.keys(actions.DataLinkApibyid).length > 0)
            {
                return {...DataLinkApibyid,DataLinkApibyid: actions.DataLinkApibyid};
            }
            else
            {
                return {...DataLinkApibyid,DataLinkApibyid: []};
            }
        case GET_DATA_ACTION_LinkApibyid_FAILED:
            return {...DataLinkApibyid,DataLinkApibyid: []};
        default:
            return DataLinkApibyid;
    }
}

export const DataEmailAzureByNameReducer = (DataEmailAzure = [], actions) => {
    switch (actions.type) {
        case GET_DATA_EMAIL_AZURE_SUCCEEDED:
            if(Object.keys(actions.DataEmailAzure).length > 0)
            {
                return {...DataEmailAzure, DataEmailAzure: actions.DataEmailAzure};
            }
            else
            {
                return {...DataEmailAzure, DataEmailAzure: []};
            }
        case REQUEST_DATA_EMAIL_AZURE_FAILED:
            return {...DataEmailAzure, DataEmailAzure: []};
        default:
            return DataEmailAzure;
    }
}
export const DataValidateDateReducer = (DataValidate = [], actions) => {
    switch (actions.type) {
        case GET_DATA_VALIDATE_DATE_SUCCEEDED:
            if(Object.keys(actions.DataValidate).length > 0)
            {
                return {...DataValidate, DataValidate: actions.DataValidate};
            }
            else
            {
                return {...DataValidate, DataValidate: []};
            }
        case REQUEST_GET_DATA_VALIDATE_DATE_FAILED:
            return {...DataValidate, DataValidate: []};
        default:
            return DataValidate;
    }
}
export const DataPlanByPassReducer = (DataPlan = [], actions) => {
    switch (actions.type) {
        case GET_DATA_PLAN_BY_PASS_SUCCEEDED:
            if(Object.keys(actions.DataPlan).length > 0)
            {
                return {...DataPlan, DataPlan: actions.DataPlan};
            }
            else
            {
                return {...DataPlan, DataPlan: []};
            }
        case REQUEST_DATA_PLAN_BY_PASS_FAILED:
            return {...DataPlan, DataPlan: []};
        default:
            return DataPlan;
    }
}